import { Trash } from "@phosphor-icons/react";

export const LoanTable = ({ list, onDelete }) => (
  <div className="bg-white border border-stone-200 rounded-lg overflow-x-auto" data-testid="loans-table">
    <table className="w-full text-sm">
      <thead>
        <tr className="text-left text-xs uppercase tracking-wide text-stone-500 border-b border-stone-200">
          <th className="px-5 py-4">Employee</th>
          <th className="px-5 py-4 text-right">Principal</th>
          <th className="px-5 py-4 text-right hidden sm:table-cell">Per month</th>
          <th className="px-5 py-4 text-right hidden md:table-cell">Recovered</th>
          <th className="px-5 py-4 text-right">Outstanding</th>
          <th className="px-5 py-4">Status</th>
          <th className="px-5 py-4"></th>
        </tr>
      </thead>
      <tbody className="divide-y divide-stone-100">
        {list.length === 0 && <tr><td colSpan={7} className="px-5 py-10 text-center text-stone-400">No loans or advances recorded yet.</td></tr>}
        {list.map((l) => (
          <tr key={l.id}>
            <td className="px-5 py-3"><span className="font-semibold">{l.employee_name}</span><div className="text-xs text-stone-500">{l.employee_code} · from {l.start_month}{l.remarks ? ` · ${l.remarks}` : ""}</div></td>
            <td className="px-5 py-3 text-right tabular-nums">₹{l.principal.toLocaleString("en-IN")}</td>
            <td className="px-5 py-3 text-right tabular-nums hidden sm:table-cell">₹{l.monthly_installment.toLocaleString("en-IN")}</td>
            <td className="px-5 py-3 text-right tabular-nums hidden md:table-cell">₹{(l.principal - l.outstanding).toLocaleString("en-IN")}</td>
            <td className="px-5 py-3 text-right tabular-nums font-bold">₹{l.outstanding.toLocaleString("en-IN")}</td>
            <td className="px-5 py-3">
              <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${l.status === "active" ? "bg-amber-50 text-amber-700" : "bg-green-50 text-green-700"}`}>
                {l.status === "active" ? "Recovering" : "Closed"}
              </span>
            </td>
            <td className="px-5 py-3 text-right">
              {(!l.repayments || l.repayments.length === 0) && (
                <button onClick={() => onDelete(l.id)} data-testid={`delete-loan-${l.id}`}
                  className="text-stone-400 hover:text-red-600 transition-colors duration-200"><Trash size={16} /></button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
